/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IHighwayCarrierQueryVariables = Types.Exact<{
  carrierApplicationId: Types.Scalars['ID']
}>

export type IHighwayCarrierQuery = { __typename?: 'Query' } & {
  highwayCarrier?: Types.Maybe<
    { __typename?: 'HighwayCarrier' } & Pick<
      Types.IHighwayCarrier,
      | 'id'
      | 'brokerAuthority'
      | 'continuousAuthorityGrantDate'
      | 'dbaName'
      | 'dotNumber'
      | 'driverOosInspections'
      | 'ein'
      | 'fatalCrashes'
      | 'fmcsaContactPhone'
      | 'highwayId'
      | 'injuryCrashes'
      | 'isMonitored'
      | 'legalName'
      | 'mcNumber'
      | 'motorCarrierId'
      | 'operatingStatus'
      | 'rulesAssessmentPass'
      | 'safetyRating'
      | 'vehicleOosInspections'
      | 'createdAt'
      | 'updatedAt'
    > & {
        addresses: Array<
          { __typename?: 'HighwayAddress' } & Pick<
            Types.IHighwayAddress,
            | 'city'
            | 'countryCode'
            | 'id'
            | 'isType'
            | 'postalCode'
            | 'stateCode'
            | 'street1'
            | 'street2'
          >
        >
        contacts: Array<
          { __typename?: 'HighwayContact' } & Pick<
            Types.IHighwayContact,
            'emailAddress' | 'isType' | 'name' | 'phone' | 'id'
          >
        >
        insurancePolicies: Array<
          { __typename?: 'HighwayInsurancePolicy' } & Pick<
            Types.IHighwayInsurancePolicy,
            | 'actualCashValue'
            | 'anyAuto'
            | 'cancellationDate'
            | 'coverageLimit'
            | 'createdAt'
            | 'effectiveDate'
            | 'expirationDate'
            | 'hiredAutos'
            | 'id'
            | 'isRefrigerationBreakdownIncluded'
            | 'isType'
            | 'nonOwnedAutos'
            | 'ownedAutos'
            | 'policyNumber'
            | 'scheduledAutos'
            | 'status'
            | 'statutoryLimits'
            | 'updatedAt'
          > & {
              insuranceCertificate?: Types.Maybe<
                { __typename?: 'HighwayInsuranceCertificate' } & Pick<
                  Types.IHighwayInsuranceCertificate,
                  'contentType' | 'createdAt' | 'filename' | 'id' | 'updatedAt' | 'url'
                >
              >
              insurer?: Types.Maybe<
                { __typename?: 'HighwayInsurer' } & Pick<
                  Types.IHighwayInsurer,
                  | 'city'
                  | 'createdAt'
                  | 'id'
                  | 'naic'
                  | 'name'
                  | 'phone'
                  | 'postalCode'
                  | 'shortName'
                  | 'state'
                  | 'street1'
                  | 'street2'
                  | 'updatedAt'
                  | 'website'
                >
              >
            }
        >
        rulesAssessments: Array<
          { __typename?: 'HighwayRulesAssessment' } & Pick<
            Types.IHighwayRulesAssessment,
            'classificationName' | 'id' | 'result' | 'ruleName' | 'createdAt' | 'updatedAt'
          > & {
              override?: Types.Maybe<
                { __typename?: 'RulesAssessmentOverride' } & Pick<
                  Types.IRulesAssessmentOverride,
                  'id' | 'result'
                >
              >
            }
        >
      }
  >
}

export const HighwayCarrierDocument = gql`
  query HighwayCarrier($carrierApplicationId: ID!) {
    highwayCarrier(carrierApplicationId: $carrierApplicationId) {
      addresses {
        city
        countryCode
        id
        isType
        postalCode
        stateCode
        street1
        street2
      }
      id
      brokerAuthority
      contacts {
        emailAddress
        isType
        name
        phone
        id
      }
      continuousAuthorityGrantDate
      dbaName
      dotNumber
      driverOosInspections
      ein
      fatalCrashes
      fmcsaContactPhone
      highwayId
      injuryCrashes
      insurancePolicies {
        actualCashValue
        anyAuto
        cancellationDate
        coverageLimit
        createdAt
        effectiveDate
        expirationDate
        hiredAutos
        id
        insuranceCertificate {
          contentType
          createdAt
          filename
          id
          updatedAt
          url
        }
        insurer {
          city
          createdAt
          id
          naic
          name
          phone
          postalCode
          shortName
          state
          street1
          street2
          updatedAt
          website
        }
        isRefrigerationBreakdownIncluded
        isType
        nonOwnedAutos
        ownedAutos
        policyNumber
        scheduledAutos
        status
        statutoryLimits
        updatedAt
      }
      isMonitored
      legalName
      mcNumber
      motorCarrierId
      operatingStatus
      rulesAssessmentPass
      rulesAssessments {
        classificationName
        id
        override {
          id
          result
        }
        result
        ruleName
        createdAt
        updatedAt
      }
      safetyRating
      vehicleOosInspections
      createdAt
      updatedAt
    }
  }
`

/**
 * __useHighwayCarrierQuery__
 *
 * To run a query within a React component, call `useHighwayCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighwayCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighwayCarrierQuery({
 *   variables: {
 *      carrierApplicationId: // value for 'carrierApplicationId'
 *   },
 * });
 */
export function useHighwayCarrierQuery(
  baseOptions: Apollo.QueryHookOptions<IHighwayCarrierQuery, IHighwayCarrierQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IHighwayCarrierQuery, IHighwayCarrierQueryVariables>(
    HighwayCarrierDocument,
    options
  )
}
export function useHighwayCarrierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IHighwayCarrierQuery, IHighwayCarrierQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IHighwayCarrierQuery, IHighwayCarrierQueryVariables>(
    HighwayCarrierDocument,
    options
  )
}
export type HighwayCarrierQueryHookResult = ReturnType<typeof useHighwayCarrierQuery>
export type HighwayCarrierLazyQueryHookResult = ReturnType<typeof useHighwayCarrierLazyQuery>
export type HighwayCarrierQueryResult = Apollo.QueryResult<
  IHighwayCarrierQuery,
  IHighwayCarrierQueryVariables
>
